module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.haveUser) ? _c('div', [(_vm.userIsSuspended) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "alert-icon far fa-exclamation-triangle"
  }), _vm._v("\n      This account is suspended, an invoice is 35 days overdue, please contact Arrow Logistics\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.hasUnpaidInvoices) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "alert-icon far fa-exclamation-triangle"
  }), _vm._v("\n      This account has " + _vm._s(_vm.user.unpaid_invoices_count) + " unpaid invoices\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-md-6-lg-3"
  }, [(_vm.user.isCarrier) ? _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'loads.index',
        query: {
          user: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-fw fa-clipboard-list"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Loads")])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isCarrier) ? _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'trucks.index',
        query: {
          user: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-fw fa-truck-container"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Trucks")])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isCarrier) ? _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'drivers.index',
        query: {
          user: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-id-card"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Drivers")])])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'jobs.index',
        query: {
          user: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-fw fa-list"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Jobs")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'locations.index',
        query: {
          user: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-fw fa-map-signs"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Locations")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'users.account-users',
        params: {
          id: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-fw fa-users"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Users")])])])])])], 1), _vm._v(" "), (_vm.user.isCarrier) ? _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'payments.index',
        query: {
          user: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-fw fa-money-check-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Payments")])])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('router-link', {
    staticClass: "ibox ibox-account-button",
    attrs: {
      "to": {
        name: 'users.edit',
        params: {
          id: _vm.user.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('i', {
    staticClass: "far fa-fw fa-cog"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("Settings")])])])])])], 1)]), _vm._v(" "), (_vm.user.isCarrier) ? _c('div', {
    staticClass: "margin-10"
  }) : _vm._e(), _vm._v(" "), (_vm.user.isCarrier) ? _c('section', {
    staticClass: "job-overview m-t-lg m-b-lg"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-load-breakdown list-detail-load-breakdown-carrier"
  }, _vm._l((_vm.loads), function(load) {
    return _c('load-item', {
      key: load.id,
      attrs: {
        "load": load
      }
    })
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoLoads),
      expression: "haveNoLoads"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No loads found.")])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'loads.index'
      }
    }
  }, [_vm._v("View All Scheduled Loads")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.user.isCarrier) ? _c('div', {
    staticClass: "margin-10"
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "job-overview m-t-lg m-b-lg"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("assets/img/icon-job.svg")
    }
  }), _vm._v(" Jobs "), _c('router-link', {
    staticClass: "material-plus job-new",
    attrs: {
      "to": {
        name: 'jobs.create'
      },
      "data-toggle": "tooltip",
      "data-placement": "left",
      "title": "Create New Job"
    }
  }, [_vm._v("+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-job"
  }, _vm._l((_vm.jobs), function(job) {
    return _c('job-item', {
      key: job.id,
      attrs: {
        "job": job
      }
    })
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoJobs),
      expression: "haveNoJobs"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No jobs found.")])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.index'
      }
    }
  }, [_vm._v("View All Jobs")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "margin-10"
  }), _vm._v(" "), _c('section', {
    staticClass: "dashboard-section m-t-lg m-b-lg"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-invoice"
  }, [_vm._l((_vm.invoices), function(invoice) {
    return _c('invoice-item', {
      key: invoice.id,
      attrs: {
        "invoice": invoice
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoInvoices),
      expression: "haveNoInvoices"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No invoices found.")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'invoices.index'
      }
    }
  }, [_vm._v("View All Invoices")])], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "far fa-clipboard-list"
  }), _vm._v(" Loads")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "far fa-file-invoice"
  }), _vm._v(" Invoices")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3f53d026"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/AdminOverview.vue
// module id = 974
// module chunks = 0